import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './MedicalLossRatioSCHERow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';

interface MedicalLossRatioSCHEHeaderProps {
  readonly helmet: HeaderHelmetProps;
  readonly showPercentPointChange?: boolean;
}

export default function MedicalLossRatioSCHEHeader({ helmet }: MedicalLossRatioSCHEHeaderProps) {
  const { showBenchmark } = useContext(AppContext);
  const { year } = useContext(AppContext);
  return (
    <>
      <div
        className={`${styles.container} ${styles.med_loss_ratio_sche_hdr} ${
          showBenchmark ? '' : styles.collapse
        }`}>
        <HeaderHelmet label="" hasBenchmarkAnalysis={false} />
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
        <h5>Preliminary MLR</h5>
        <h5>Underwriting Gain(Loss)</h5>
      </div>
      <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
        <HeaderHelmet {...helmet} />
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
        <h5 className="column_align_right">Pt. Chg</h5>
        <h5 className="column_align_right">{year}</h5>
        <h5 className="column_align_right">{year - 1}</h5>
        <h5 className="column_align_right">Pt. Chg</h5>
        <h5 className="column_align_right">{year}</h5>
        <h5 className="column_align_right">{year - 1}</h5>
      </div>
    </>
  );
}
